export const SERVER = [
  [
    { managetypeId: 'SMS', rsctypeId: 'CPU', rscId: 'TOTAL_USERATE', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'SMS', rsctypeId: 'CPU', rscId: 'SYS_USERATE', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'SMS', rsctypeId: 'CPU', rscId: 'USER_USERATE', rscKey: '_', orderbyIndex: 3 },
  ],
  [{ managetypeId: 'SMS', rsctypeId: 'MEM_PHY', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'SMS', rsctypeId: 'MEM_SWP', rscId: 'USERATE', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'SMS', rsctypeId: 'DISK', rscId: 'DISK_USERATE', orderbyIndex: 1 }],
  [{ managetypeId: 'SMS', rsctypeId: 'DISKIO', rscId: 'DISKIO_BUSY', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'SMS', rsctypeId: 'NETIO', rscId: 'NETIO_BPS_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'SMS', rsctypeId: 'NETIO', rscId: 'NETIO_BPS_OUT', rscKey: '_', orderbyIndex: 2 }],
];

export const NETDEVICE = [
  [{ managetypeId: 'NMS', rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_ICMP', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_SNMP', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_PERF', rscId: 'CPU_USERATE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_PERF', rscId: 'MEM_USERATE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_PERF', rscId: 'DEVICE_TEMP', rscKey: '_', orderbyIndex: 1 }],
];

export const WIRELESS_DEVICE = {
  AP_CONTROLLER: [
    [{ managetypeId: 'NMS', rsctypeId: 'WIRELESS_CONTROLLER', rscId: 'CLIENT_COUNT', rscKey: '_', orderbyIndex: 1 }],
    [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_', orderbyIndex: 2 }],
    [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_PERF', rscId: 'CPU_USERATE', rscKey: '_', orderbyIndex: 1 }],
    [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_PERF', rscId: 'MEM_USERATE', rscKey: '_', orderbyIndex: 1 }],
    [{ managetypeId: 'NMS', rsctypeId: 'DEVICE_PERF', rscId: 'DEVICE_TEMP', rscKey: '_', orderbyIndex: 1 }],
    [{ managetypeId: 'NMS', rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_ICMP', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'RESPONSETIME', rscId: 'RESPONSETIME_SNMP', rscKey: '_', orderbyIndex: 2 }],
  ],
  WIRELESSAP: [
    [{ managetypeId: 'NMS', rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'CLIENT_COUNT', rscKey: '_', orderbyIndex: 1 }],
    [{ managetypeId: 'NMS', rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_OUT', rscKey: '_', orderbyIndex: 2 }],
    [{ managetypeId: 'NMS', rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_RSSI', rscKey: '_', orderbyIndex: 1 }],
    [{ managetypeId: 'NMS', rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_SNR', rscKey: '_', orderbyIndex: 1 }],
  ],
};

export const POE = [{ managetypeId: 'NMS', rsctypeId: 'POE', rscId: 'POWER_CONSUMED', rscKey: '_', orderbyIndex: 1 }];

export const NETINTERFACE = [
  [{ managetypeId: 'NMS', rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'NMS', rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_OUT', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'NMS', rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_OUT', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'NMS', rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_IN', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'NMS', rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_OUT', rscKey: '_', orderbyIndex: 2 }],
];

export const DBMS = [
  [{ managetypeId: 'DBMS', rsctypeId: 'SESS', rscId: 'DB_SESS_COUNT', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'DBMS', rsctypeId: 'LOCK', rscId: 'DB_LOCK_COUNT', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'DBMS', rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'DBMS', rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_USERATE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'DBMS', rsctypeId: 'SYSSTAT', rscId: 'DB_RESPONSETIME', rscKey: '_', orderbyIndex: 1 }],
];

export const E2E_SERVICE = [[{ managetypeId: 'E2E', rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_TOTAL', orderbyIndex: 1 }]];

export const FTHEHYGRO = [[{ managetypeId: 'FMS', rsctypeId: 'FTHEHYGRO', rscId: 'CUR_HUMIDITY', rscKey: '_', orderbyIndex: 1 }], [{ managetypeId: 'FMS', rsctypeId: 'FTHEHYGRO', rscId: 'CUR_TEMPERATURE', rscKey: '_', orderbyIndex: 2 }]];

export const FTEMP = [
  [
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE1', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE2', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE3', rscKey: '_', orderbyIndex: 3 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE4', rscKey: '_', orderbyIndex: 4 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE5', rscKey: '_', orderbyIndex: 5 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE6', rscKey: '_', orderbyIndex: 6 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE7', rscKey: '_', orderbyIndex: 7 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE8', rscKey: '_', orderbyIndex: 8 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE9', rscKey: '_', orderbyIndex: 9 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE10', rscKey: '_', orderbyIndex: 10 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE11', rscKey: '_', orderbyIndex: 11 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE12', rscKey: '_', orderbyIndex: 12 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE13', rscKey: '_', orderbyIndex: 13 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE14', rscKey: '_', orderbyIndex: 14 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE15', rscKey: '_', orderbyIndex: 15 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE16', rscKey: '_', orderbyIndex: 16 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE17', rscKey: '_', orderbyIndex: 17 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE18', rscKey: '_', orderbyIndex: 18 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE19', rscKey: '_', orderbyIndex: 19 },
    { managetypeId: 'FMS', rsctypeId: 'FTEMP', rscId: 'TEMPERATURE20', rscKey: '_', orderbyIndex: 20 },
  ],
];

export const FTH = [[{ managetypeId: 'FMS', rsctypeId: 'FTH', rscId: 'HUMIDITY', rscKey: '_', orderbyIndex: 1 }], [{ managetypeId: 'FMS', rsctypeId: 'FTH', rscId: 'TEMPERATURE', rscKey: '_', orderbyIndex: 2 }]];

export const FVSBMS = [
  [
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_R', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_S', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_T', rscKey: '_', orderbyIndex: 3 },
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_R', rscKey: '_', orderbyIndex: 4 },
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_S', rscKey: '_', orderbyIndex: 5 },
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_T', rscKey: '_', orderbyIndex: 6 },
  ],
  [
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'CURRENT_R', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'CURRENT_S', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'CURRENT_T', rscKey: '_', orderbyIndex: 3 },
  ],
  [{ managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'POWER', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'POWER_FACTOR', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'FREQUENCY', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'HORIZONTAL_RADIATION', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'TILT_RADIATION', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'MODULE_TEMPERATURE', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'FMS', rsctypeId: 'FVSBMS', rscId: 'OUTSIDE_TEMPERATURE', rscKey: '_', orderbyIndex: 2 }],
];

export const FUPS = [
  [{ managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'INPUT_VOLTAGE', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'OUTPUT_VOLTAGE', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'INPUT_CURRENT', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'OUTPUT_CURRENT', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'INPUT_FREQUENCY', rscKey: '_', orderbyIndex: 1 }, { managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'OUTPUT_FREQUENCY', rscKey: '_', orderbyIndex: 2 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'TEMPERATURE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'BATTERY_CURRENT', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'BATTERY_VOLTAGE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FUPS', rscId: 'CAPACITY', rscKey: '_', orderbyIndex: 1 }],
];

export const FGCU = [
  [
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'BATTERY_VOLTAGE', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_R', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_S', rscKey: '_', orderbyIndex: 3 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_T', rscKey: '_', orderbyIndex: 4 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_R', rscKey: '_', orderbyIndex: 5 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_S', rscKey: '_', orderbyIndex: 6 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_T', rscKey: '_', orderbyIndex: 7 },
  ],
  [
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'APPARENT_PWR', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'REACTIVE_PWR', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'ACTIVE_PWR', rscKey: '_', orderbyIndex: 3 },
  ],
  [
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_R', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_S', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_T', rscKey: '_', orderbyIndex: 3 },
  ],
  [{ managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'OIL_PRESS', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'WATER_TEMP', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'FMS', rsctypeId: 'FGCU', rscId: 'GEN_FREQUENCY', rscKey: '_', orderbyIndex: 1 }],
];

export const FRT = [
  [
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'DC_VOLTAGE', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'BATTERY_VOLTAGE', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'LOAD_VOLTAGE', rscKey: '_', orderbyIndex: 3 },
  ],
  [
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'DC_CURRENT', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'BATTERY_CURRENT', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'LOAD_CURRENT', rscKey: '_', orderbyIndex: 3 },
  ],
  [
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'INPUT_FREQUENCY_A', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'INPUT_FREQUENCY_B', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'INPUT_FREQUENCY_C', rscKey: '_', orderbyIndex: 3 },
  ],
  [{ managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'LOAD_FACTOR', rscKey: '_', orderbyIndex: 1 }],
  [
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'POWER_FACTOR_A', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'POWER_FACTOR_B', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'FMS', rsctypeId: 'FRT', rscId: 'POWER_FACTOR_C', rscKey: '_', orderbyIndex: 3 },
  ],
];

export const VCL = [
  [{ managetypeId: 'VMS', rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'VMS', rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_', orderbyIndex: 2 }],
];

export const VHO = [
  [{ managetypeId: 'VMS', rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'VMS', rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
  [
    { managetypeId: 'VMS', rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'VMS', rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_', orderbyIndex: 2 },
  ],
  [
    { managetypeId: 'VMS', rsctypeId: 'VHO_NETWORK', rscId: 'BPS_IN', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'VMS', rsctypeId: 'VHO_NETWORK', rscId: 'BPS_OUT', rscKey: '_', orderbyIndex: 2 },
  ],
];

export const VVM = [
  [{ managetypeId: 'VMS', rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'VMS', rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'VMS', rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
  [
    { managetypeId: 'VMS', rsctypeId: 'VVM_DISK', rscId: 'BPS_READ', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'VMS', rsctypeId: 'VVM_DISK', rscId: 'BPS_WRITE', rscKey: '_', orderbyIndex: 2 },
  ],
  [
    { managetypeId: 'VMS', rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'VMS', rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_', orderbyIndex: 2 },
  ],
];

export const VDSC = [
  [{ managetypeId: 'VMS', rsctypeId: 'VDSC_STORAGE', rscId: 'AVSIZE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'VMS', rsctypeId: 'VDSC_STORAGE', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
];

export const VDS = [
  [{ managetypeId: 'VMS', rsctypeId: 'VDS_STORAGE', rscId: 'AVSIZE', rscKey: '_', orderbyIndex: 1 }],
  [{ managetypeId: 'VMS', rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_', orderbyIndex: 1 }],
];

export const WAS = [
  [
    { managetypeId: 'APM2X', rsctypeId: 'SERVICE', rscId: 'ELAPSED_TIME', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'APM2X', rsctypeId: 'SERVICE', rscId: 'APITIME_BY_SERVICE', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'APM2X', rsctypeId: 'SERVICE', rscId: 'SQLTIME_BY_SERVICE', rscKey: '_', orderbyIndex: 3 },
  ],
  [
    { managetypeId: 'APM2X', rsctypeId: 'HOST', rscId: 'CPU', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'APM2X', rsctypeId: 'HOST', rscId: 'SWAP', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'APM2X', rsctypeId: 'HOST', rscId: 'MEM', rscKey: '_', orderbyIndex: 3 },
  ],
  [
    { managetypeId: 'APM2X', rsctypeId: 'ENDUSER', rscId: 'FIRST_BYTE_TIME', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'APM2X', rsctypeId: 'ENDUSER', rscId: 'DOM_BUILDING_TIME', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'APM2X', rsctypeId: 'ENDUSER', rscId: 'DOM_READY_TIME', rscKey: '_', orderbyIndex: 3 },
    { managetypeId: 'APM2X', rsctypeId: 'ENDUSER', rscId: 'RESOURCE_FETCH_TIME', rscKey: '_', orderbyIndex: 4 },
    { managetypeId: 'APM2X', rsctypeId: 'ENDUSER', rscId: 'RESPONSE_TIME', rscKey: '_', orderbyIndex: 5 },
  ],
  [
    { managetypeId: 'APM2X', rsctypeId: 'JVM', rscId: 'HEAP_USAGE', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'APM2X', rsctypeId: 'JVM', rscId: 'PERM_PERCENT', rscKey: '_', orderbyIndex: 2 },
  ],
  [
    { managetypeId: 'APM2X', rsctypeId: 'SERVICE', rscId: 'TPS', rscKey: '_', orderbyIndex: 1 },
    { managetypeId: 'APM2X', rsctypeId: 'ENDUSER', rscId: 'AJAX_TPS', rscKey: '_', orderbyIndex: 2 },
    { managetypeId: 'APM2X', rsctypeId: 'JDBC', rscId: 'SQL_TPS', rscKey: '_', orderbyIndex: 3 },
  ],
];

export const ChartConst = { SERVER, NETDEVICE, WIRELESS_DEVICE, POE, NETINTERFACE, DBMS, E2E_SERVICE, FTHEHYGRO, FTEMP, FTH, FVSBMS, FUPS, FGCU, FRT, VCL, VHO, VVM, VDSC, VDS, WAS };



// WEBPACK FOOTER //
// ./src/constants/chart-analysis.js